/** Validate only immediately observable Kuali editor prerequisites. */
import type { ConnectorCredentialSource } from '../../types'
import type {
  KualiResearchConnectionStatus,
  KualiResearchModuleOptions,
} from '../types'

export function kualiResearchFormError({
  apiUrl,
  modules,
  credentialSource,
  connection,
  apiKey,
}: {
  apiUrl: string
  modules: KualiResearchModuleOptions[]
  credentialSource: ConnectorCredentialSource
  connection: KualiResearchConnectionStatus
  apiKey: string
}): string | null {
  if (!apiUrl) return 'Enter the Kuali Research API URL'
  if (!modules.length) return 'Select at least one Kuali Research module'
  for (const module of modules) {
    if (!Number.isInteger(module.limit) || module.limit < 1) {
      return `Enter a valid ${module.source} sync limit`
    }
    if (module.filters.some(filter => !filter.value.trim())) {
      return `Complete or remove each ${module.source} filter`
    }
    if (module.startAfter && Number.isNaN(Date.parse(module.startAfter))) {
      return `Choose a valid ${module.source} starting date`
    }
    if (module.source === 'awards' && !module.attachmentTypeCodes.length) {
      return 'Select at least one Award attachment type'
    }
  }
  const configured = credentialSource === 'workspace'
    ? connection.workspaceConfigured
    : connection.umdConfigured === true
  if (credentialSource === 'workspace' && !configured && !apiKey) {
    return 'Enter the Kuali Research system API key'
  }
  if (credentialSource === 'umd' && !configured) {
    return 'Configure the Kuali Research key in UMD Credential Store first'
  }
  return null
}
